import { render, staticRenderFns } from "./AdvancedReport.vue?vue&type=template&id=2240c708"
import script from "./AdvancedReport.vue?vue&type=script&lang=js"
export * from "./AdvancedReport.vue?vue&type=script&lang=js"
import style0 from "./AdvancedReport.vue?vue&type=style&index=0&id=2240c708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports